import { ListItemProps } from "@progress/kendo-react-dropdowns";
import { format, formatDate } from "date-fns";
import React from "react";
import { Buyer } from "interface/buyer"

export const BuyerRenderItem = (fixedLenght: boolean = true) => (
	li: React.ReactElement<HTMLLIElement>,
	itemProps: ListItemProps
) => {
	const data: Buyer = itemProps.dataItem;

	const fixedLenghtColumn = (value: string, length: number, title?: string) =>
		fixedLenght ? (
			<span style={{ display: "block", width: "180px", flexShrink: 0 }} title={title}>
				{value?.length > length ? `${value.slice(0, length-3)}...` : value}
			</span>
		) : (
			<span style={{ display: "block", flex: 1, minWidth: 0, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }} title={title}>
				{value}
			</span>
		);

	const item = (
		<div style={{ display: "flex", gap: "40px", width: "100%" }}>
			<div style={{ display: "flex", gap: "15px", flex: 1, minWidth: 0 }}>
				<span style={{ display: "block", width: "70px", flexShrink: 0 }}>
					{data.id}
				</span>
				{fixedLenghtColumn(data.name, 52, data.name)}
			</div>
		</div>
	);

	return React.cloneElement(li, li.props, item);
};

export default BuyerRenderItem;